import { useLocation } from 'react-router';
import { getLoginUrl } from './getLoginUrl';

export const useGetLoginUrl = (): string => {
  const { pathname, search, hash } = useLocation();
  return getLoginUrl(`${pathname}${search}${hash}`);
};
